<template>
  <div>
    <div id="containerHeatmap" :style="`height: 100%; width: 100%`"></div>
    <!-- Loading -->
    <div v-if="loading" style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%)" class="text-center">
      <div>{{ $t('努力加载中...') }}</div>
      <b-spinner label="Loading..." style="width: 4rem; height: 4rem" class="my-2" variant="primary" />

      <div class="text-muted">Loading ...</div>
    </div>
  </div>
</template>
<script>
import { Heatmap } from '@antv/g2plot';
import { momentJs } from '@/libs/utils/moment';
import { getDiagnosisGetRiskHeatmap } from '@/api/diagnosis';
import { routerParams } from '@/libs/utils/routerParams';

export default {
  name: 'heatmap',
  props: {
    heatmapHeight: {
      default: 700,
    },
  },
  mounted() {
    // this.initChart();
    this.doGet();
  },
  data: () => ({
    loading: false,
    filter: {
      time: momentJs().format(),
    },
  }),
  methods: {
    initChart(data) {
      // const months = Array.from(new Set(data.map(item => Number(item.month.split('-')[1]))))
      const months = Array.from(new Set(data.map((item) => item.month)));
      const resultData = {}; // key: month-day  value: data object
      for (let year_month of months) {
        const year_month_split = year_month.split('-');
        const month = Number(year_month_split[1]);
        const year = Number(year_month_split[0]);
        const strMonth = month < 10 ? '0' + month : month;
        for (let day = 1; day <= new Date(2022, month, 0).getDate(); day++) {
          const strDay = day < 10 ? '0' + day : `${day}`;
          resultData[`${year}-${strMonth}-${strDay}`] = {
            day: strDay,
            month: `${year}-${strMonth}`,
            time: `${year}-${strMonth}-${strDay}`,
            value: 0,
          };
        }
      }
      for (let item of data) {
        resultData[item['time']] = item;
      }
      const container = document.getElementById('containerHeatmap');
      const width = container.scrollWidth;
      const height = container.scrollHeight;
      const heatmapPlot = new Heatmap(document.getElementById('containerHeatmap'), {
        width,
        height: this.heatmapHeight,
        autoFit: false,
        data: Object.values(resultData),
        xField: 'month',
        yField: 'day',
        // xAxis: {
        //   visible: false,
        //   line: {
        //     visible: false
        //   }
        // },
        // yAxis: {
        //   visible: false,
        //   line: {
        //     visible: false
        //   }
        // },
        colorField: 'value',
        legend: {
          visible: true,
        },
        tooltip: {
          formatter: (data) => {
            return { name: data.month + '-' + data.day, value: data.value };
          },
        },
        // color: [
        //   "#174c83",
        //   "#7eb6d4",
        //   "#efefeb",
        //   "#efa759",
        //   "#9b4d16",
        // ],
        // meta: {
        //   "Month of Year": {
        //     type: "cat",
        //   },
        // },
      });
      heatmapPlot.render();
    },
    doGet() {
      this.loading = true;
      const timeArr = this.filter.time.replaceAll(' 至 ', ',').replaceAll(' to ', ',').split(',');
      const start = momentJs(timeArr[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss');
      const end = momentJs(timeArr[1] || timeArr[0])
        .endOf('day')
        .format('YYYY-MM-DD HH:mm:ss');
      getDiagnosisGetRiskHeatmap({ project_id: routerParams('project_id') })
        .then((res) => {
          console.log(res, 'res');
          this.initChart(res.data);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
